import React from "react";
import { Link } from "react-router-dom";

// Generic bordered card wrapper for every dashboard widget below the KPI
// row - title + optional right-aligned caption/link + a loading/empty
// fallback, so each widget's own body only has to render its real content.
const DashboardSectionCard = ({ title, headerRight, viewAllPath, isLoading, isEmpty, emptyText, children }) => (
  <div className="card h-100">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0 text-uppercase text-muted fw-semibold" style={{ fontSize: 12, letterSpacing: 0.5 }}>
          {title}
        </h6>
        {viewAllPath ? (
          <Link to={viewAllPath} className="small">View All</Link>
        ) : (
          headerRight && <span className="small text-muted">{headerRight}</span>
        )}
      </div>
      {isLoading ? (
        <p className="text-muted small mb-0">Loading...</p>
      ) : isEmpty ? (
        <p className="text-muted small mb-0">{emptyText || "Nothing to show yet."}</p>
      ) : (
        children
      )}
    </div>
  </div>
);

export default DashboardSectionCard;
